module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-panel', {
    staticStyle: {
      "box-shadow": "3px 0px 3px silver"
    },
    attrs: {
      "left": "",
      "opened": _vm.isLaptop,
      "close": _vm.loggingout
    }
  }, [_c('f7-view', {
    style: ('border-right : ' + '2px solid ' + _vm.color + ';'),
    attrs: {
      "id": "left-panel-view",
      "navbar-through": "",
      "dynamic-navbar": true
    }
  }, [_c('f7-navbar', {
    staticClass: "leftPanelNavBar"
  }, [_c('div', {
    staticClass: "leftPanelTopBlock"
  }, [_c('div', {
    staticClass: "milkyBlock",
    class: {
      boxRequest: _vm.$engine.user.validateAccess('changeProfile')
    },
    staticStyle: {
      "vertical-align": "baseline"
    },
    on: {
      "click": _vm.activateModalProfile
    }
  }, [_c('img', {
    staticClass: "navbarProfileImage",
    attrs: {
      "src": require("./../../assets/static/images/image-profile.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline-block",
      "margin": "auto"
    }
  }, [_c('span', {
    staticClass: "leftPanelNameLabel",
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "baseline"
    }
  }, [_vm._v(_vm._s(_vm.accountName))]), _vm._v(" "), (_vm.$engine.user.validateAccess('changeProfile')) ? _c('f7-icon', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "margin": "auto"
    },
    attrs: {
      "f7": "chevron_down",
      "color": "black",
      "size": "16"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.type === '1') ? _c('p', {
    staticClass: "leftPanelLoginLabel",
    staticStyle: {
      "margin-left": "33px",
      "padding-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.$t('businessMembers.mmbr')) + " : " + _vm._s(_vm.accountLogin))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "leftPanelApplicationLabel",
    style: ({
      'background-color': _vm.color
    })
  }, [_vm._v(_vm._s(_vm.$t('common.appname')) + " - " + _vm._s(_vm.serviceLabel))])])]), _vm._v(" "), _c('f7-pages', [_c('f7-page', {
    staticClass: "menuPage"
  }, [_c('services-menu', {
    attrs: {
      "type": _vm.type,
      "serviceName": _vm.serviceName
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae664ce0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae664ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftPanel/CMLeftPanel.vue
// module id = 1707
// module chunks = 2